/**
 * Minified by jsDelivr using Terser v5.39.0.
 * Original file: /npm/sorttable@1.0.2/sorttable.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
